// Add calendar days in the account timezone, without shifting the selected clock time.
export const followUpShortcut = (days, timeZone = 'Africa/Harare', now = new Date()) => {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
  }).formatToParts(now);
  const date = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return new Date(Date.UTC(Number(date.year), Number(date.month) - 1, Number(date.day) + days))
    .toISOString().slice(0, 10);
};

export const formatFollowUp = ({ date, time, dateOnly }) => {
  const label = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC', day: 'numeric', month: 'short', year: 'numeric',
  }).format(new Date(`${date}T12:00:00Z`));
  return dateOnly || !time ? `${label} · No set time` : `${label} at ${time.slice(0, 5)}`;
};

// Snoozing an upcoming follow-up must never bring it forward.
export const snoozeFollowUpDate = (date, timeZone, now = new Date()) => {
  const today = followUpShortcut(0, timeZone, now);
  const base = date > today ? date : today;
  const next = new Date(`${base}T12:00:00Z`);
  next.setUTCDate(next.getUTCDate() + 1);
  return next.toISOString().slice(0, 10);
};
